import {
    FETCH_FILTERS
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    list: []
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case FETCH_FILTERS: {
            const payload = action.payload || {};
            return {
                ...state,
                list: payload.data || []
            };
        }
        default:
            return state;
    }
};
